export default {
  backoffice: {
    // title is the name of the backoffice section: it is printed both by the
    // backoffice itself and by route.meta.title (header, breadcrumbs, tab).
    title: 'Backoffice',
    sections: {
      backoffice: 'Backoffice',
      discover: 'Discover',
      management: 'Management',
      sales: 'Orders & Sales',
      general: 'General',
    },
    nav: {
      dashboard: 'Dashboard',
      organizations: 'Organizations',
      users: 'Users',
      notifications: 'Notifications',
      products: 'Products',
      events: 'Events',
      community: 'Community',
      spots: 'Spots',
      gallery: 'Gallery',
      categories: 'Categories',
      inventory: 'Inventory',
      rents: 'Rents',
      orders: 'Orders',
      customers: 'Customers',
      applications: 'Applications',
      promotions: 'Promotions',
      payments: 'Payments',
      pages: 'Pages',
      reports: 'Reports',
    },
  },
};
